import { createMuiTheme } from "@material-ui/core/styles";

const outerTheme = createMuiTheme({
  palette: {
    primary: {
      main: "#FFFFFF",
      light: "#FFFFFF",
      dark: "#FFFFFF",
    },
    secondary: {
      main: "#FFC65B",
    },
    danger: {
      main: "#EA2828",
    },
    grey: {
      main: "#FFFFFF",
    },
  },
  overrides: {
    MuiInput: {
      root: {
        color: "#FFFFFF",
        borderBottom: "none",
      },
    },
    MuiFormLabel: {
      root: {
        color: "#FFFFFF",
        borderBottom: "none",
      },
    },
    MuiLink: {
      root: {
        color: "#707070",
        display: "flex",
        padding: "20px",
        "&:hover": {
          color: "#FFFFFF",
        },
      },
    },
    MuiListItem: {
      root: {
        "&:hover": {
          textDecoration: "none",
          backgroundColor: "red",
        },
        paddingTop: "20px",
      },
    },
    MuiTab: {
      root: {
        color: "#FFFFFF",
        "&$selected": {
          backgroundColor: "transparent",
          borderBottomColor: "blue",
        },
      },
      textColorPrimary: {
        color: "#BCBCBC",
        "&$selected": {
          color: "#FFFFFF",
        },
        "&$disabled": {
          color: "#707070",
        },
      },
    },
    MuiTextField: {
      root: {
        borderRadius: "4px",
        backgroundColor: "#707070",
        color: "#FFFFFF",
      },
    },
    MuiTableContainer: {
      root: {
        backgroundColor: "#0e1d35",
        border: "none",
      },
    },
    MuiTableCell: {
      root: {
        color: "#FFFFFF",
        borderBottom: "none",
      },
      head: {
        color: "#C2C2C2",
        fontWeight: "bold",
      },
      body: {
        color: "#FFFFFF",
        fontFamily: "Biotif-Regular",
      },
      alignRight: {
        textAlign: "right",
        flexDirection: "row-reverse",
      },
    },
    MuiTableHead: {
      root: {
        borderBottom: "0.5px solid white",
      },
    },
    MuiAccordion: {
      root: {
        backgroundColor: "transparent",
        fontSize: "1.2rem",
      },
    },
    MuiAccordionSummary: {
      root: {
        backgroundColor: "transparent",
        color: "#FFFFFF",
      },
    },
    MuiSvgIcon: {
      root: {
        fontSize: "1.5rem",
      },
    },
    MuiAutocomplete: {
      option: {
        borderBottom: "solid 1px rgb(57, 57, 57,0.15)",
        fontSize: "12px",
        fontFamily: "Biotif-Regular",
      },
      listbox: {
        padding: "10px",
      },
    },
  },
});

export default outerTheme;
